import {TextField} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, {FunctionComponent} from "react";
import {useTranslation} from "react-i18next";

export const TeamRegistrationView: FunctionComponent<any> = () => {
    const {t} = useTranslation();
    const classes = useStyles();

    return (
        <>
            <TextField
                className={classes.textField}
                name="teamName"
                required
                label={t('teamNameLabel')}
                helperText={t('teamNameHelper')}
            />
        </>);
}


const useStyles = makeStyles({
    textField: {
        width: "100%",
        maxWidth: "30rem",
    },
});